import { registerPlugin, PluginListenerHandle } from '@capacitor/core';

export interface DeviceVolumePlugin {
  getVolume(): Promise<{ level: number }>;
  addListener(eventName: 'volumeChange', listenerFunc: (event: { level: number }) => void): Promise<PluginListenerHandle>;
}

const DeviceVolume = registerPlugin<DeviceVolumePlugin>('DeviceVolume');

export { DeviceVolume };
